export const RESET = 'PRODUCTPRICETYPE_LIST_RESET'
export const SET_ITEMS = 'PRODUCTPRICETYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'PRODUCTPRICETYPE_LIST_SET_ERROR'
export const SET_VIEW = 'PRODUCTPRICETYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'PRODUCTPRICETYPE_LIST_TOGGLE_LOADING'
